import request from '../config/request'


export const SajlhaSignInAPI = async (body: any) => {
  const response = await request({
    url: `/sajlha/signin`,
    body: body,
    method: 'POST',
    customURl: true,
  });

  return response;
}



export const OauthAuthorization = async (body: any) => {
  const response = await request({
    url: `/oauth/authorize?${body}`,
    body: body,
    method: 'GET',
    customURl: true,
  });

  return response;
}

export const SajlhaOtpVerificationAPI = async (body: any) => {
  const response = await request({
    url: `/sajlha/otp-verification`,
    body: body,
    method: 'POST',
    customURl: true,
  });

  return response;
}

export const SajlhaResendOTP = async (body: any) => {
  const response = await request({
    url: `/sajlha/otp-verification`,
    body: body,
    method: 'POST',
    customURl: true,
  });

  return response;
}



